// components/CustomPagination.jsx
import React from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";

const CustomPagination = ({ paginationModel, setPaginationModel, totalRows = 10, pageSize = 10 }) => {
// if (totalRows <= pageSize) return null;
    return (
        <Pagination
            count={Math.ceil((totalRows || 10) / pageSize)} // ✅ Default totalRows to 10 if not provided
            page={paginationModel?.page + 1 || 1} // ✅ Default page to 1
            onChange={(_, newPage) =>
                setPaginationModel((prev) => ({ ...prev, page: newPage - 1 }))
            }
            shape="rounded"
            color="primary"
            sx={{
                "& .MuiPaginationItem-root": {
                    color: "#141C36", // ✅ Dark blue text color
                    fontWeight: "500",
                    border: "1px solid #4169E1", // ✅ Added border
                    borderRadius: "8px", // ✅ Rounded corners
                    padding: "5px 10px", // ✅ Adjusted padding
                    backgroundColor: "transparent", // ✅ Ensure default buttons are transparent
                },
                "& .Mui-selected": {
                    backgroundColor: "#D5E0FF !important", // ✅ Light blue background for the active page
                    color: "#141C36 !important", // ✅ Dark text for contrast
                    border: "1px solid #4169E1 !important", // ✅ Keep a border for the selected page
                },
                "& .css-11iewuh-MuiPagination-root .MuiPaginationItem-root": {
                    border: "1px solid #4169E1", // ✅ Specific class styling
                },
                "& .css-1qnpzw5-MuiPagination-root .Mui-selected": {
                    backgroundColor: "#EAEFFF", // ✅ Apply light blue color for selected page
                }
            }}
            renderItem={(item) => <PaginationItem {...item} />}
        />
    );
};

export default CustomPagination;
